module.exports = __webpack_public_path__ + "static/media/Hat_4.b96a76f2.jpg";